import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: _vm.drawerWidth,
      temporary: "",
      persistent: "",
      stateless: _vm.isStatelessDrawer
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: "",
      disabled: _vm.isSavingAndSending
    },
    on: {
      click: _vm.close
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("h2", [_vm._v(_vm._s(_vm.purchaseOrder.number) + " - Save & Send")])], 1)]), _c(VStepper, {
    key: _vm.steps.length,
    attrs: {
      vertical: ""
    },
    model: {
      value: _vm.currentStep,
      callback: function callback($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, _vm._l(_vm.steps, function (step) {
    return _c("div", {
      key: "step_".concat(step.id)
    }, [_c(VStepperStep, {
      attrs: {
        step: step.id,
        complete: _vm.currentStep > step.id,
        rules: step.rules,
        editable: ""
      }
    }, [_vm._v(" " + _vm._s(step.title) + " "), _c("small", [_vm._v(_vm._s(step.inf))])]), step.key === "mail" ? _c(VStepperContent, {
      key: "mail_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [_vm.warehouse.mail ? _c("div", {
      staticClass: "mail-container"
    }, [_c(VTextField, {
      attrs: {
        label: "Warehouse mail",
        disabled: true,
        "hide-details": "auto"
      },
      model: {
        value: _vm.warehouse.mail,
        callback: function callback($$v) {
          _vm.$set(_vm.warehouse, "mail", $$v);
        },
        expression: "warehouse.mail"
      }
    }), _c("div", {
      staticClass: "mail-icons"
    }, [_c(VTooltip, {
      attrs: {
        top: ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c(VIcon, _vm._g(_vm._b({
            attrs: {
              small: ""
            },
            on: {
              click: function click($event) {
                return _vm.copyToClipboard(_vm.warehouse.mail);
              }
            }
          }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
        }
      }], null, true)
    }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
      staticStyle: {
        color: "green"
      }
    }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1)], 1) : _vm._e(), _vm.supplier.email ? _c("div", {
      staticClass: "mail-container"
    }, [_c(VTextField, {
      attrs: {
        label: "Supplier mail",
        disabled: true,
        "hide-details": "auto"
      },
      model: {
        value: _vm.supplier.email,
        callback: function callback($$v) {
          _vm.$set(_vm.supplier, "email", $$v);
        },
        expression: "supplier.email"
      }
    }), _c("div", {
      staticClass: "mail-icons"
    }, [_c(VTooltip, {
      attrs: {
        top: ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref2) {
          var on = _ref2.on,
            attrs = _ref2.attrs;
          return [_c(VIcon, _vm._g(_vm._b({
            attrs: {
              small: ""
            },
            on: {
              click: function click($event) {
                return _vm.copyToClipboard(_vm.supplier.email);
              }
            }
          }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
        }
      }], null, true)
    }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
      staticStyle: {
        color: "green"
      }
    }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1), _vm.purchaseOrder.isSupplierNotifSended !== null && _vm.purchaseOrder.isSupplierNotifSended !== undefined ? _c("div", {
      staticClass: "status-row"
    }, [_vm.purchaseOrder.isSupplierNotifSended ? _c(VChip, {
      staticClass: "status-chip",
      attrs: {
        color: "green darken-2",
        "text-color": "white",
        small: ""
      }
    }, [_c(VIcon, {
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-email-check")]), _vm._v(" Supplier notified ")], 1) : _c(VChip, {
      staticClass: "status-chip",
      attrs: {
        outlined: "",
        color: "grey darken-2",
        small: ""
      }
    }, [_c(VIcon, {
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-email-alert")]), _vm._v(" Supplier not notified ")], 1)], 1) : _vm._e()], 1) : _vm._e(), _c(VExpansionPanels, {
      on: {
        change: _vm.changePanel
      },
      model: {
        value: _vm.openedPanel,
        callback: function callback($$v) {
          _vm.openedPanel = $$v;
        },
        expression: "openedPanel"
      }
    }, _vm._l(_vm.form.emailTemplates, function (emailTemplate, i) {
      return _c(VExpansionPanel, {
        key: "expansion-panel_".concat(i),
        attrs: {
          id: "expansion-panel_".concat(i)
        }
      }, [_c(VExpansionPanelHeader, [_c(VBtn, {
        staticClass: "expansion-panel-header-close-btn",
        attrs: {
          icon: "",
          "data-cy": "step-mail-close-btn"
        },
        on: {
          click: function click($event) {
            return _vm.deleteTemplatePanel(i);
          }
        }
      }, [_c(VIcon, [_vm._v("mdi-close")])], 1), _vm._v(" " + _vm._s(emailTemplate.name) + " ")], 1), _c(VExpansionPanelContent, [!_vm.flattenPlaceholders.length ? _c(VSkeletonLoader, {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          type: "image"
        }
      }) : _vm._e(), [_vm.isNeedingSync ? _c(VBtn, {
        staticClass: "sync-btn",
        attrs: {
          rounded: "",
          loading: _vm.isSyncing
        },
        on: {
          click: _vm.syncLatestVersion
        }
      }, [_c(VIcon, [_vm._v("mdi-lightning-bolt")]), _vm._v(" Sync latest version ")], 1) : _vm._e(), _vm.openedPanel === i ? _c("MailTemplateForm", {
        key: "step_template_".concat(emailTemplate.id, "_").concat(i),
        attrs: {
          purchaseOrder: _vm.purchaseOrder,
          placeholders: _vm.emailPlaceholders,
          templates: _vm.emailTemplates,
          isDeletingTemplate: _vm.isDeletingTemplate,
          withRelatedFiles: ""
        },
        on: {
          edit: _vm.editTemplate,
          delete: _vm.deleteTemplate,
          change: _vm.changeTemplate,
          "click:new": _vm.newTemplate,
          "click:placeholder": _vm.clickPlaceholder
        },
        model: {
          value: _vm.form.emailTemplates[i],
          callback: function callback($$v) {
            _vm.$set(_vm.form.emailTemplates, i, $$v);
          },
          expression: "form.emailTemplates[i]"
        }
      }) : _vm._e()]], 2)], 1);
    }), 1), _c(VBtn, {
      staticClass: "new-email-btn",
      attrs: {
        rounded: ""
      },
      on: {
        click: _vm.newEmail
      }
    }, [_c(VIcon, [_vm._v("mdi-plus")]), _vm._v(" new e-mail ")], 1), _c(VDivider), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        "data-cy": "step-mail-continue-btn"
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v(" Continue ")])], 1)], 1) : _vm._e(), step.key === "synthesis" ? _c(VStepperContent, {
      key: step.id,
      attrs: {
        step: step.id
      }
    }, [_c("div", {
      staticClass: "mt-4"
    }, [_c("div", {
      staticClass: "text-smaller text-italic"
    }, [_vm._v("Mail title: Purchase order created")]), _c("div", {
      staticClass: "d-flex align-center"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: _vm.preventWarehouseNotification,
        callback: function callback($$v) {
          _vm.preventWarehouseNotification = $$v;
        },
        expression: "preventWarehouseNotification"
      }
    }), _vm.preventWarehouseNotification ? _c("span", {
      staticClass: "text-red text-bold"
    }, [_vm._v(" Will NOT notify warehouse by automatic platform mail ")]) : _c("span", {
      staticClass: "text-green text-bold"
    }, [_vm._v(" Will notify warehouse by automatic platform mail ")])], 1)]), _c("div", {
      staticClass: "stepper-btn"
    }, [_c("div", {
      staticClass: "erros"
    }, [_vm.isInvalidForm ? _c("div", {
      staticClass: "text-red text-bold"
    }, [_vm._v(" Please fill in all required fields in the e-mail(s) before proceeding. ")]) : _vm._e()]), _c(VBtn, {
      attrs: {
        color: "primary",
        disabled: _vm.isInvalidForm || !_vm.purchaseOrder.items.length,
        loading: _vm.isSavingAndSending,
        "data-cy": "step-synthesis-continue-btn"
      },
      on: {
        click: _vm.saveAndSend
      }
    }, [_vm._v(" " + _vm._s(_vm.form.emailTemplates.length > 0 || !_vm.preventWarehouseNotification ? "Save & Send" : "Save") + " ")])], 1)]) : _vm._e()], 1);
  }), 0)], 1), _vm.templateModalShown ? _c("MailTemplateModal", {
    attrs: {
      shown: _vm.templateModalShown,
      placeholders: _vm.emailPlaceholders,
      template: _vm.editableTemplate
    },
    on: {
      save: _vm.saveTemplate,
      close: _vm.closeTemplateModal
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };